import mixpanel from 'mixpanel-browser';

const isProd = process.env.NODE_ENV === 'production';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

export const Mixpanel = {
	init: () => {
		if (!MIXPANEL_TOKEN) {
			console.warn('Mixpanel token is not defined.');
			return;
		}
		try {
			mixpanel.init(MIXPANEL_TOKEN as string, {
				autotrack: false,
				debug: !isProd,
				// track_pageview doesn't seem to work well in SPA or if autotrack is false.
				// For this reason, we trigger pageview via trackPageView() below. See
				// src/features/Analytics/Analytics.tsx for implementation.
				// track_pageview: true,
				loaded: (mixpanel) => {
					console.log('Mixpanel initialized', mixpanel);
				},
			});
		} catch (error) {
			console.error('Mixpanel init failed:', error);
		}
	},

	identify: (id: string) => {
		mixpanel.identify(id);
	},

	track: (eventName: string, eventProperties: Record<string, any>) => {
		mixpanel.track(eventName, eventProperties);
	},

	trackPageView: (eventProperties: Record<string, any>) => {
		mixpanel.track_pageview(eventProperties);
	},

	addUserProperties: (userProperties: Record<string, any>) => {
		delete userProperties.userId;

		mixpanel.people.set(userProperties);
	},

	reset: () => {
		mixpanel?.reset();
	},
};
